module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "noMargin"
  }, [(_vm.objAuthorize.privileges.indexOf('CREATE_EDIT_DELETE_PROJECTS') !== -1) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('div', {
    staticClass: "pageTitle"
  }, [_c('h2', [_vm._v("PROJECTS")])]), _vm._v(" "), _c('v-btn', {
    staticClass: "elevation-5",
    attrs: {
      "color": "info"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fncAddProject.apply(null, arguments)
      }
    }
  }, [_vm._v("Create Project")]), _vm._v(" "), _c('v-btn', {
    staticClass: "elevation-5",
    attrs: {
      "color": "info"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fncReloadProjects.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons reloadButton"
  }, [_vm._v("refresh")])])], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}